<!-- Stepper -->
@defer {
  <div class="stepper-sticky-wrapper">
    <kendo-stepper
      [steps]="steps()" stepType="full" [currentStep]="currentStep()" [linear]="isLinear()"
      [successSVGIcon]="successIcon" [errorSVGIcon]="errorIcon" (currentStepChange)="stepChange.emit($event)"
      (activate)="stepActivate.emit($event)" #stepper></kendo-stepper>
  </div>
  <!-- Component Container -->
  <div>
    <ng-content></ng-content>
  </div>
}
